module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAAAXNSR0IArs4c6QAAAKNJREFUKFOd0b9NgnEQBuDndQNGcQU6K0oSKioSQqcmFkqnnUQrE1usCQO4gQzjABZnfubDQMCQeO3dc39y8Y9IM1W1wUeS2V89qmqBfpLzLbrHLZYYJ6ldXFWvmGCR5PoHddMaaniNYZKvqjrDG0Ytl2Tean9RB6/wiHdcYIUB7pI8bAfsoQ5O8YJP9HCZ5Gl33QPUwTGecZOk3bMXR9GpL3wDGOsxCZa9bb4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down.png
// module id = w80D
// module chunks = 1